 <template>
    <div class=''>
        <el-pagination background layout="prev, pager, next" @current-change='currentChange' :pager-count="pagerCount" :total="total" :page-size='pageSize' />
    </div>
</template>

<script setup>
import { reactive, defineEmits, defineProps } from 'vue'

const props = defineProps({
    total: {
        type: Number,
        default: 0,
    },
    pageNum: {
        type: Number,
        default: 1,
    },
    pageSize: {
        type: Number,
        default: 1,
    },
    pagerCount: {
        type: Number,
        default: 7
    }
})
const emit = defineEmits(['currentChange', 'update:pageNum'])
const currentChange = (e) => {
    emit('update:pageNum', e);
    emit('currentChange', e);
}
</script>

<style scoped lang='scss'>
</style>